import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { RestService } from './rest.service';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
    
    constructor(private rest:RestService) { }
  
    public login(username: string, password: string):any {
        return this.rest.post("login",{ username, password, loginType:"BROWSER" }).pipe(map(user => {
            // login successful if there's a jwt token in the response
            if (user) {
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                localStorage.setItem('currentUser', JSON.stringify(user));
            }
            return user;
        }));
    }

    logout() {
        // remove user from local storage to log user out
        // localStorage.removeItem('currentUser');
        localStorage.clear();
    }

    isAuthTokenValid(parsedToken: string) {
        return this.rest.post('isAuthTokenValid', parsedToken);
    }

    public forgotPassword(username: string): any {
        return this.rest.post("forgotPassword", username);
    }

    public isResetTokenValid(token: string): any{
        return this.rest.get('isResetTokenValid', token);
    }

    public resetPassword(token: string, password: string): any {
        return this.rest.post("resetPassword", { token, password });
    }

    public changePassword(username: string, oldPassword: string, newPassword: string):any {
        return this.rest.put("changePassword",{ username, oldPassword, newPassword });
    }

}